import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ThemeProvider } from './theme/ThemeProvider';
import { installClientLogger } from './lib/clientLogger';
import { installTelemetry } from './lib/telemetry';
import './i18n';
import './styles.css';

// Item 71 Phase E — install the SIEM-bound error forwarder before
// the first render so any error thrown during bootstrap (bad lazy
// import, missing env var, transient network blip on the first SWR
// fetch) lands in the same `component=frontend` log stream as
// runtime errors. Idempotent if hot-module-reload wires it again.
installClientLogger();

// Item 106 Phase F — install the Frontend RUM trace-context
// auto-injector before any SWR/fetch fires, so the very first
// API call carries a traceparent header that the backend's
// otelhttp middleware (Item 22) can stitch onto its inbound
// server span. Default-OFF when VITE_OTEL_EXPORTER_OTLP_ENDPOINT
// is empty — air-gapped installs ship with the env var unset and
// transmit nothing.
installTelemetry({
  endpointURL: import.meta.env.VITE_OTEL_EXPORTER_OTLP_ENDPOINT || '',
  serviceName: import.meta.env.VITE_OTEL_SERVICE_NAME || undefined,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
);
